import { type FC } from 'react'

import {
  AfterSalesImageControlImageThumbnail,
  type AfterSalesImageControlImageThumbnailImage,
} from './AfterSalesImageControlImageThumbnail'

export const AfterSalesImageControlImageThumbnailList: FC<{
  images: AfterSalesImageControlImageThumbnailImage[]
  onRemoveImage: (index: number) => void
}> = ({ images, onRemoveImage }) => {
  return (
    <div className="flex flex-wrap gap-3">
      {images.map((image, index) => (
        <AfterSalesImageControlImageThumbnail
          handleRemoveImage={() => {
            onRemoveImage(index)
          }}
          image={image}
          key={image.previewUrl}
        />
      ))}
    </div>
  )
}
